/*
 * <prism-recently-viewed> — renders the shopper's genuine browsing history.
 * Reads product handles from localStorage (written by prism-recently-viewed-recorder),
 * fetches each product's JSON, and builds accessible cards. No fabricated data.
 *
 * Attributes:
 *   data-limit     max number of products to show
 *   data-current   handle of the current product (excluded), optional
 *   data-money     money format string with {{amount}}
 */
if (!customElements.get('prism-recently-viewed')) {
  customElements.define(
    'prism-recently-viewed',
    class PrismRecentlyViewed extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.prism-rv__grid');
        this.limit = parseInt(this.getAttribute('data-limit') || '4', 10);
        this.current = this.getAttribute('data-current') || '';
        this.money = this.getAttribute('data-money') || '${{amount}}';
        this.render();
      }

      getHandles() {
        try {
          const list = JSON.parse(localStorage.getItem('prism:recently-viewed') || '[]');
          return list.filter((h) => h && h !== this.current).slice(0, this.limit);
        } catch (e) {
          return [];
        }
      }

      formatMoney(cents) {
        return this.money.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
      }

      async render() {
        const handles = this.getHandles();
        if (handles.length === 0) {
          this.hidden = true; // graceful empty state: no history yet
          return;
        }
        try {
          const products = await Promise.all(
            handles.map((h) =>
              fetch(window.Shopify.routes.root + 'products/' + h + '.js')
                .then((r) => (r.ok ? r.json() : null))
                .catch(() => null)
            )
          );
          const html = products
            .filter(Boolean)
            .map((p) => this.cardHTML(p))
            .join('');
          if (!html) {
            this.hidden = true;
            return;
          }
          this.grid.innerHTML = html;
          this.hidden = false;
        } catch (e) {
          this.hidden = true;
        }
      }

      cardHTML(p) {
        const img = p.featured_image
          ? '<img src="' +
            p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') +
            '" alt="" loading="lazy" width="400" height="500" class="prism-rv__img">'
          : '<span class="prism-rv__img prism-rv__img--empty"></span>';
        const url = (window.Shopify.routes.root + 'products/' + p.handle).replace(/\/\//g, '/');
        return (
          '<li class="prism-rv__card">' +
          '<a class="prism-rv__link" href="' +
          url +
          '">' +
          '<span class="prism-rv__media">' +
          img +
          '</span>' +
          '<span class="prism-rv__title">' +
          this.escape(p.title) +
          '</span>' +
          '<span class="prism-rv__price">' +
          this.formatMoney(p.price) +
          '</span>' +
          '</a></li>'
        );
      }

      escape(str) {
        const d = document.createElement('div');
        d.textContent = str;
        return d.innerHTML;
      }
    }
  );
}
